import apiCall from "./axios_instance";
import config from '../config.json';
import { v4 as uuidv4 } from 'uuid';

export async function logoutSession() {
    try {
        const objResp = await apiCall.delete(`authentication/v1/user/session`);
        return objResp;
    } catch (error) {
        console.error("Error in  logoutSession API ->", error.message);
        throw error;
    }
}


export async function loginSession(payload, flag) {
    try {
        /* if (config.EncryptionMethod) {
            var objResp = await apiCallEncrypted.post(`authentication/v1/user/session`, payload);
        } else {
            objResp = await apiCall.post(`authentication/v1/user/session`, payload);
        } */
        const objResp = await apiCall.post(`authentication/v1/user/session`, payload, { isAllowedDeviceInfo: true });
        // const objResp = { data: {} };
        // objResp.data = { "status": "error", "code": "e-101", "message": "Your password has expired. Kindly login using UserId/Password.", "errors": "e-1" };
        return objResp;
    } catch (error) {
        if (!flag) {
            console.error("Error in loginSession API ->", error.message);
            throw error;
        } else {
            return { status: true, data: error };
        }

    }
}


export async function createAccount(payload) {
    try {
        const objResp = await apiCall.post(`authentication/v1/user/createaccount`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in createAccount API ->", error.message);
        throw error;
    }
}

export async function userDetails(userId) {
    try {
        const objResp = await apiCall.get(`authentication/${config.TenantId}/v1/getUserDetails/${userId}`);
        return objResp;
    } catch (error) {
        console.error("Error in userDetails API ->", error.message);
        throw error;
    }
}

export async function changePassword(payload) {
    try {
        const objResp = await apiCall.put(`authentication/v1/user/password`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in changePassword API ->", error.message);
        throw error;
    }
}


export async function sendOTP(payload) {
    let objPayload = { ...payload, lock: true };
    try {
        const objResp = await apiCall.post(`authentication/v1/user/password/reset/send-otp`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in sendOTP API ->", error.message);
        throw error;
    }
}

//Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Ends

export async function changeNewPassword(payload) {
    try {
        const objResp = await apiCall.put(`authentication/v1/user/password/reset`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in changeNewPassword API ->", error.message);
        throw error;
    }
}

export async function sendMpinOTP(payload) {
    try {
        const objResp = await apiCall.post(`authentication/v1/user/mpin/reset/send-otp`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in sendMpinOTP API ->", error.message);
        throw error;
    }
}

//Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Ends


export async function verifyOTP(payload) {
    try {
        const objResp = await apiCall.post(`authentication/v1/user/otp/verify`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in verifyOTP API ->", error.message);
        throw error;
    }
}

// Ajitesh verify totp api call on enable/disable totp flow
export async function verifyTOTP(payload) {
    try {
        const objResp = await apiCall.post(`authentication/v1/user/verifytotp`, payload, { isAllowedDeviceInfo: true });
        return objResp;
    } catch (error) {
        console.error("Error in verifyTOTP API ->", error.message);
        throw error;
    }
}

export async function registerTOTP(payload) {
    try {
        const objResp = await apiCall.post(`authentication/v1/user/registertotp`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in verifyOTP API ->", error.message);
        throw error;
    }
}

// Ajitesh 07-08-2024 Api to delete/disbale TOTP from settings
export async function deleteTOTP() {
    try {
        const objResp = await apiCall.delete("authentication/v1/user/registertotp");
        return objResp;
    } catch (error) {
        console.error("Error in deleteTOTP API ->", error.message);
        throw error;
    }
}

export async function generateQR(payload) {
    try {
        const objResp = await apiCall.post(`authentication/v1/user/session/generateQR`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in generateQR API ->", error.message);
        throw error;
    }
}

export async function registerMPIN(payload) {
    try {
        const objResp = await apiCall.post(`authentication/v1/user/mpin/reset/verify-otp`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in registerMPIN API ->", error.message);
        throw error;
    }
}


/* Abhijeet V Created Guest login flow apis starts here */

export async function setGuestRegDetail(payload) {
    try {
        const objPayload = { ...payload, guestAllowed: true };
        const objResp = await apiCall.post(`/authentication/${config.TenantId}/v1/setGuestRegDetail`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in guest registration API ->", error.message);
        throw error;
    }
}

export async function validateGuestOTP(payload) {
    try {
        const objPayload = { ...payload, guestAllowed: true };
        const objResp = await apiCall.post(`/authentication/${config.TenantId}/v1/validateGuestOTP`, objPayload);
        return objResp;
    } catch (error) {
        console.error("Error in validate guest otp  API ->", error.message);
        throw error;
    }
}

/* Abhijeet V Created Guest login flow apis ends here */




export async function userProfile() {
    try {
        const objResp = await apiCall.get(`authentication/v1/user/profile`);
        return objResp;
    } catch (error) {
        console.error("Error in userProfile API ->", error.message);
        throw error;
    }
}

export async function dynamicProductTypes() {
    try {
        const objResp = await apiCall.get(`/authentication/v1/getDynamicProductTypes`, { lock: true });
        return objResp;
    } catch (error) {
        console.error("Error in dyamic product types ->", error.message);
        throw error;
    }
}

export async function changeMpin(payload) {
    try {
        const objResp = await apiCall.put(`authentication/v1/user/mpin`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in registerMPIN API ->", error.message);
        throw error;
    }
}

export async function forgotUserId(payload) {
    try {
        const objResp = await apiCall.get(`authentication/v1/user/details?pan=${payload.panNum}`, {
            headers: {
                'api_key': payload.api_key
            }
        });
        return objResp;
    } catch (error) {
        console.error("Error in forgotUserId API ->", error.message);
        throw error;
    }
}

export async function getInfo() {

    const payload = {
        "deviceinfo": {
            "UDID": uuidv4(),
            "DeviceModel": "Breeze",
            "DeviceSerialNo": "",
            "DeviceManufacturer": window.navigator.vendor,
            "DevicePlatform": "web",
            "DevicePlatformVer": window.navigator.userAgent,
            "Longitude": "",
            "Latitude": "",
            "AppName": "Breeze",
            "AppVersion": window.navigator.appVersion,
            "AppVersionCode": "2000000",
            "AppPackageName": "Breeze",
            "FCMRegKey": window.location.host,
            "IP": ""
        }
    };


    try {
        const objResp = await apiCall.post(`authentication/${config.TenantId}/v1/info`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in guest registration API ->", error.message);
        throw error;
    }
}

export async function handshake(payload) {
    try {
        const objResp = await apiCall.post(`authentication/${config.TenantId}/v1/handshake`, payload);
        return objResp;
    } catch (error) {
        console.error("Error in guest registration API ->", error.response);
        return error.response.data;
    }
}

//Azeem K : 14-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --Start
export async function getUserOtt() {
    //BREEZE-16857 : LLD Comment: API call function of getting Modern Algo token
    try {
        const objResp = await apiCall.get(`authentication/v1/sdk/user/ott/1`);
        return objResp;
    } catch (error) {
        console.error("Error in guest ott API ->", error.response);
        return error.response.data;
    }
}
//Azeem K : 14-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --End